// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"4e2b057e","356":"8b815b1e","401":"c6108b86","901":"e0ffc622"}[chunkId] + ".css";
};